module.exports = __webpack_public_path__ + "img/Gastronomía.6b693a1d.svg";